<script setup lang="ts">
import { computed } from 'vue';
import { useLeaveFeedbackReminder } from './useLeaveFeedbackReminder.ts';
import FadeTransition from '@/shared/components/transitions/FadeTransition.vue';

// This is a blinking dot that hints to the user about the need to leave a review.
// The dot is displayed in the bottom navigation bar and in the side menu.
// We show the dot on the 4th day after
// the user registers in the application, and then every 7 days
// of active use of the application
// The dot is displayed all day.

const dotVisible = computed(() => {
  return !savedData.value.feedbackAdded && isTimeToRemindFeedback.value;
});

const {
  isTimeToRemindFeedback,
  savedData,
} = useLeaveFeedbackReminder();

</script>

<template>
  <FadeTransition :visible="dotVisible">
    <div class="leave-feedback-dot pulse" />
  </FadeTransition>
</template>

<style scoped>
.leave-feedback-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(180deg, rgba(254, 167, 65, 0.50) 0%, rgba(175, 69, 155, 0.50) 100%), #FFB562;
}

.pulse {
  box-shadow: 0 0 0 rgba(254, 167, 65, 0.4);
  animation: pulse 2s infinite;
}

.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 167, 65, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 5px rgba(254, 167, 65, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 167, 65, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 167, 65, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 167, 65, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 5px rgba(254, 167, 65, 0);
      box-shadow: 0 0 0 5px rgba(254, 167, 65, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 167, 65, 0);
      box-shadow: 0 0 0 0 rgba(254, 167, 65, 0);
  }
}
</style>
